export class Size {
  sizeId;
  sizeName;
  sizeWidth;
  sizeHeight;
  sizePrice;
  sizeCanvasPrice;

  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
